export const GET_VENDORS_BY_LOCATION_REQUEST = 'GET_VENDORS_BY_LOCATION_REQUEST';
export const GET_VENDORS_BY_LOCATION_SUCCESS = 'GET_VENDORS_BY_LOCATION_SUCCESS';
export const GET_VENDORS_BY_LOCATION_FAILURE = 'GET_VENDORS_BY_LOCATION_FAILURE';

export const RESET_VENDORS_BY_LOCATION_STATE = 'RESET_VENDORS_BY_LOCATION_STATE';